module.exports = __webpack_public_path__ + "img/logo-login.eef8f844.svg";